<template>
  <div class="row" style="margin-bottom: 26px;" v-if="!pagamento && pagRec == 'R'">
    <div class="col-md-12" v-if="emailsDisponiveis.length">
      <div
        style="border: 1px solid rgb(235, 237, 243); border-radius: 0.42rem; padding: 16px;"
      >
        <b-form>
          <h3 class="card-label" style="margin-bottom: 1.75rem;">
            Enviar Cobrança via E-mail
          </h3>

          <b-form-group>
            <div
              v-for="emailDisponivel in emailsDisponiveis"
              :key="emailDisponivel.email"
            >
              <b-form-checkbox
                v-model="emailDisponivel.enviar"
                :value="1"
                :unchecked-value="0"
                size="lg"
              >
                {{ emailDisponivel.email }}
              </b-form-checkbox>
            </div>
          </b-form-group>

          <b-button
            class="margin-btn-5"
            @click="enviarEmailCobrancaAfirma"
            variant="success"
            style="margin-right: 6px;"
            :disabled="carregandoEnvio"
          >
            <b-spinner
              v-if="carregandoEnvio"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Enviar
          </b-button>
          <b-button
            class="margin-btn-5"
            @click="enviarEmailCobrancaCancela"
            variant="danger"
            :disabled="carregandoEnvio"
          >
            <b-spinner
              v-if="carregandoEnvio"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Cancelar
          </b-button>
        </b-form>
      </div>
    </div>
    <div class="col-md-4" v-if="!emailsDisponiveis.length">
      <b-button
        class="margin-btn-5 btn-block"
        @click="enviarEmailCobranca"
        variant="success"
        :disabled="carregandoEnvio"
      >
        <b-spinner
          v-if="carregandoEnvio"
          small
          style="margin-bottom: 2px; margin-right: 3px;"
        ></b-spinner>
        Enviar Cobrança via E-mail
      </b-button>
    </div>
    <div class="col-md-4" v-if="!emailsDisponiveis.length">
      <b-button
        class="margin-btn-5 btn-block"
        @click="enviarSMSCobranca"
        variant="warning"
        :disabled="carregandoEnvio"
      >
        <b-spinner
          v-if="carregandoEnvio"
          small
          style="margin-bottom: 2px; margin-right: 3px;"
        ></b-spinner>
        Enviar Cobrança via SMS
      </b-button>
    </div>
    <div class="col-md-4" v-if="!emailsDisponiveis.length">
      <b-button
        class="margin-btn-5 btn-block"
        @click="enviarWhatsAppCobranca"
        variant="primary"
        :disabled="carregandoEnvio"
      >
        <b-spinner
          v-if="carregandoEnvio"
          small
          style="margin-bottom: 2px; margin-right: 3px;"
        ></b-spinner>
        <img
          v-if="!carregandoEnvio"
          src="media/logos/whatsapp.svg.webp"
          style="width: 17px;"
        />
        Enviar Cobrança via WhatsApp
      </b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "BotoesEnvio",
  data() {
    return {
      carregandoEnvio: false,
      emailsDisponiveis: []
    };
  },
  props: ["idEmitente", "idFluxoDeCaixa", "pagRec", "pagamento", "telefones"],
  methods: {
    ...mapActions([
      "getEmitenteEmails",
      "getEnviarEmailFluxo",
      "getEnviarSMSFluxo"
    ]),
    validarEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validarCelulares(voltaDDD = false) {
      let celular = "";
      let ddd = "";

      this.telefones.forEach(function(telefone) {
        if (!celular) {
          if (
            telefone.E_CELULAR == 1 &&
            (telefone.TELEFONE.length == 8 || telefone.TELEFONE.length == 9)
          ) {
            celular = telefone.TELEFONE;
            ddd = telefone.DDD;
          }
        }
      });

      return (voltaDDD ? ddd : "") + celular;
    },
    async enviarEmailCobranca() {
      let vm = this;

      let emails = [];

      let data = await this.getEmitenteEmails(this.idEmitente);

      if (data.length) {
        if (data[0].ACESSOS_REMOTOS_DESC) {
          data[0].ACESSOS_REMOTOS_DESC = data[0].ACESSOS_REMOTOS_DESC.split(
            "\n"
          );
        } else {
          data[0].ACESSOS_REMOTOS_DESC = [];
        }

        if (data[0].ACESSOS_REMOTOS_NOME) {
          data[0].ACESSOS_REMOTOS_NOME = data[0].ACESSOS_REMOTOS_NOME.split(
            "\n"
          );
        } else {
          data[0].ACESSOS_REMOTOS_NOME = [];
        }

        data[0].ACESSOS_REMOTOS_DESC.forEach(function(acessoRemotoDesc, index) {
          if (acessoRemotoDesc.toUpperCase().indexOf("BOLET") >= 0) {
            if (vm.validarEmail(data[0].ACESSOS_REMOTOS_NOME[index].trim())) {
              emails.push({
                email: data[0].ACESSOS_REMOTOS_NOME[index].trim(),
                enviar: 1
              });
            }
          }
        });
      }

      if (emails.length) {
        this.emailsDisponiveis = emails;
      } else {
        Swal.fire({
          title: "",
          text: "Nenhum e-mail válido no emitente!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        });
      }
    },
    async enviarEmailCobrancaAfirma() {
      let emails = [];

      this.emailsDisponiveis.forEach(function(email) {
        if (email.enviar) {
          emails.push(email.email);
        }
      });

      if (emails.length) {
        let e = await Swal.fire({
          title: "",
          text:
            "Confirma o envio para " +
            emails.length +
            " e-mail(s) selecionado(s)?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim, enviar!",
          cancelButtonText: "Cancelar"
        });

        if (e.value) {
          this.carregandoEnvio = true;

          let dados = await this.getEnviarEmailFluxo({
            idFluxoCaixa: this.idFluxoDeCaixa,
            emails: btoa(JSON.stringify(emails))
          });

          this.carregandoEnvio = false;

          this.emailsDisponiveis = [];

          if (!dados.resultado) {
            if (dados.descricao) {
              Swal.fire({
                title: "",
                text: dados.descricao,
                icon: "error",
                confirmButtonClass: "btn btn-secondary"
              });
            } else {
              Swal.fire({
                title: "",
                text: "Ocorreu um erro, não foi possível enviar o e-mail.",
                icon: "error",
                confirmButtonClass: "btn btn-secondary"
              });
            }
          } else {
            Swal.fire({
              title: "",
              text: "Enviado com sucesso.",
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            });
          }
        } else {
          this.emailsDisponiveis = [];
        }
      } else {
        Swal.fire({
          title: "",
          text: "É necessário selecionar algum e-mail antes de enviar.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        });
      }
    },
    enviarEmailCobrancaCancela() {
      this.emailsDisponiveis = [];
    },
    async enviarSMSCobranca() {
      if (this.validarCelulares()) {
        let e = await Swal.fire({
          title: "",
          text:
            "Confirma o envio de SMS para " + this.validarCelulares(true) + "?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim, enviar!",
          cancelButtonText: "Cancelar"
        });

        if (e.value) {
          this.carregandoEnvio = true;
          let dados = await this.getEnviarSMSFluxo(this.idFluxoDeCaixa);
          this.carregandoEnvio = false;

          if (!dados.resultado) {
            if (dados.descricao) {
              Swal.fire({
                title: "",
                text: dados.descricao,
                icon: "error",
                confirmButtonClass: "btn btn-secondary",
                heightAuto: false
              });
            } else {
              Swal.fire({
                title: "",
                text: "Ocorreu um erro, não foi possível enviar o SMS.",
                icon: "error",
                confirmButtonClass: "btn btn-secondary",
                heightAuto: false
              });
            }
          } else {
            Swal.fire({
              title: "",
              text: "O SMS foi enviado com sucesso.",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false
            });
          }
        }
      } else {
        Swal.fire({
          title: "",
          text: "Celular inválido!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false
        });
      }
    },
    enviarWhatsAppCobranca() {
      Swal.fire({
        title: "",
        text: "Em desenvolvimento.",
        icon: "warning",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false
      });
    }
  }
};
</script>
